import { server } from 'helpers/config';

const SERVER_URL = server.apiHost;

export default {
  NOTIFICATION: `${SERVER_URL}/t2b/notification/notifications/`,
  COUNTS:'count/',
  DELETE:'delete/'
}